// extracted by mini-css-extract-plugin
var _1 = "StarRatingAndReviews-module__count___w_wOd";
var _2 = "StarRatingAndReviews-module__ratingAndReview___AXPZr";
var _3 = "StarRatingAndReviews-module__starRating___a9euL";
export { _1 as "count", _2 as "ratingAndReview", _3 as "starRating" }
